import logo from '../../assets/logo'
import permission from './permission'
export default {
  Empresa: {},
  Logo: logo,
  Profile: {},
  Loading: false,
  Themes: [
    {
      name: 'Modelo 01',
      modal: 'EnbModal01',
      checkout: 'CheckoutSide01',
      search: 'SearchCont01',
      nave: 'EnbNave01',
      footer: 'EnbFooter01',
      route: 'Theme01',
      active: true
    },
    {
      name: 'Modelo 02',
      modal: 'EnbModal02',
      checkout: 'CheckoutSide01',
      search: 'SearchCont01',
      nave: 'EnbNave02',
      footer: 'EnbFooter01',
      route: 'Theme02',
      active: false
    },
    {
      name: 'Modelo 03',
      modal: 'EnbModal03',
      checkout: 'CheckoutSide01',
      search: 'SearchCont01',
      nave: 'EnbNave03',
      footer: 'EnbFooter03',
      route: 'Theme03',
      active: false
    }
  ],
  Theme: {
    name: 'Modelo 01',
    modal: 'EnbModal01',
    checkout: 'CheckoutSide01',
    search: 'SearchCont01',
    nave: 'EnbNave01',
    footer: 'EnbFooter01',
    route: 'Theme01',
    active: true
  },
  EnbMsg: [],
  Users: [],
  SelectedUserEdit: {
    usuario: '',
    nome: '',
    sobrenome: '',
    email: '',
    senha: '',
    permissao: []
  },
  UserValidate: {
    usuario: { $invalid: false, has: { $message: '', $invalid: false } },
    nome: { $invalid: false, has: { $message: '', $invalid: false } },
    sobrenome: { $invalid: false },
    email: { $invalid: false, has: { $message: '', $invalid: false } },
    senha: { $invalid: false },
    csenha: { $invalid: false }
  },
  Permission: permission,
  SearchLoad: false,
  Fonts: [
    {
      name: 'Gordita'
    },
    {
      name: 'Arima'
    },
    {
      name: 'Poppins'
    }
  ],
  Prefes: {
    global: {
      font: 'Gordita'
    },
    nave: {
      corBackground: '#EEEEEE',
      corFont: '#000000',
      font: 'Gordita'
    },
    frentelojaCorFundo: {
      corBackground: '#EEEEEE'
    },
    frentelojaCorFonte: {
      color: '#000000'
    },
    lojaCorFonte: {
      color: '#000000'
    },
    lojaCorPadrao: {
      corBackground: '#CCCCCC'
    },
    lojaCorFundo: {
      corBackground: '#FFFFFF'
    },
    btn: {
      corBackground: 'green',
      corFont: '#000000',
      font: 'Gordita'
    },
    produto: {
      corBackground: '#FFFFFF',
      corFont: '#000000',
      font: 'Gordita'
    },
    btnProduto: {
      corBackground: 'green',
      corFont: '#000000',
      font: 'Gordita'
    },
    rodape: {
      corBackground: '#333333',
      corFont: '#FFFFFF',
      font: 'Gordita'
    },
    cart: {
      corBackground: '#333333',
      corFont: '#FFFFFF',
      font: 'Gordita',
      icon: 'CartIcon01'
    },
    spinner: {
      tipo: 'EnbSyncLoader',
      cor: '#000000'
    }
  },
  PWrecovery: {}
}
